import React from 'react';
import { FlatList as RNFlatList, FlatListProps as RNFlatListProps } from 'react-native';

export type FlatListProps<T> = Omit<RNFlatListProps<T>, 'keyExtractor'> & {
  // Default behavior is for `keyExtractor` to be optional.
  // We force `keyExtractor` to be explicitly passed as a prop,
  // because the fallback of using list indices does not work
  // if `data` get updated/filtered/rearranged. The best practice
  // is to uniquely identify each element (e.g. with planId), but if
  // this is not required, the user can explicitly pass:
  // keyExtractor={(item, index) => index.toString()}
  keyExtractor: NonNullable<RNFlatListProps<T>['keyExtractor']>;
};

export default function FlatList<T>(props: FlatListProps<T>) {
  return (
    <RNFlatList<T>
      keyboardShouldPersistTaps="handled"
      removeClippedSubviews={false}
      showsHorizontalScrollIndicator={false}
      showsVerticalScrollIndicator={false}
      {...props}
    />
  );
}

export type EncapsulatedFlatListProps<T, U> = Omit<
  FlatListProps<T>,
  'data' | 'renderItem' | 'keyExtractor'
> & {
  data: T[];
  // Note: we require itemProps because the item may have required props
  // that we want to enforce. If itemProps is optional, then the require
  // props of the underlying item component would not be enforced.
  itemProps: U;
};
